import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0b0c10] telesis-grain relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-10 telesis-tape opacity-40" />
      <nav className="relative z-10 flex items-center justify-between px-6 py-5 md:px-12">
        <Link to="/" className="telesis-eyebrow">Telesis · CAI</Link>
        <div className="flex gap-3">
          <Link to="/feed" className="text-sm text-slate-300 hover:text-yellow-400">Feed</Link>
          <Link to="/login" className="text-sm text-slate-300 hover:text-yellow-400">Sign in</Link>
        </div>
      </nav>

      <section className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 pt-16 pb-10">
        <p className="telesis-eyebrow">Conditional Additional Income · Est. 2026</p>
        <h1 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-black tracking-tight leading-[0.95] text-slate-50 max-w-4xl">
          Mentate. Vote. <span className="text-yellow-400">Redistribute.</span><br />
          A social media where feeling is the <span className="italic text-emerald-400">ledger</span>.
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed">
          Telesis is a membership social canvas. 20.21 CAD a month unlocks unlimited <span className="font-mono text-yellow-300">Mentational Faculties</span> — the "For" and "Against" votes that approve or bounce every piece of posted mentation. Posts carry a visible emotion hue (deeper fonçé = heavier emotion) and a pixelation grain (fine = consistent, coarse = unsettled).
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/login">
            <Button className="rounded-full bg-yellow-400 text-black hover:bg-yellow-300 font-semibold px-6">
              Join · 20.21 CAD / month
            </Button>
          </Link>
          <Link to="/feed">
            <Button variant="outline" className="rounded-full border-[#2a2f3f] bg-transparent text-slate-100 hover:bg-[#1a1d28] px-6">
              Browse the mentation
            </Button>
          </Link>
        </div>
      </section>

      <section className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 py-10">
        <p className="telesis-eyebrow mb-3">Membership tiers</p>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="telesis-panel rounded p-6">
            <p className="telesis-eyebrow">Base</p>
            <p className="text-4xl font-black mt-2 text-slate-100">$20.21 <span className="text-sm font-mono text-slate-500">CAD / mo</span></p>
            <p className="mt-3 text-sm text-slate-300">100 Mentational Faculty votes per month. Active membership required for monthly redistribution payout eligibility.</p>
          </div>
          <div className="telesis-panel rounded p-6 border-l-2 border-yellow-400/60">
            <p className="telesis-eyebrow text-yellow-400">Unlimited</p>
            <p className="text-4xl font-black mt-2 text-yellow-400">$55.69 <span className="text-sm font-mono text-slate-500">CAD / mo</span></p>
            <p className="mt-3 text-sm text-slate-300">Unlimited votes per month. Same share of monthly redistribution as any active member.</p>
          </div>
        </div>
      </section>

      <section className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 py-14 grid md:grid-cols-3 gap-4">
        {[
          { k: "25%", t: "Of every membership to Steven Craig Boileau", a: "text-yellow-400" },
          { k: "15%", t: "Pain & Suffering Compensation, per-capita claimable", a: "text-rose-400" },
          { k: "60%", t: "Redistribution Pool — first-come, cap 2% per request", a: "text-emerald-400" },
        ].map((x) => (
          <div key={x.k} className="telesis-panel rounded p-6 telesis-rise">
            <p className={`text-5xl font-black tracking-tight ${x.a}`}>{x.k}</p>
            <p className="mt-3 text-sm text-slate-300 leading-relaxed">{x.t}</p>
          </div>
        ))}
      </section>

      <section className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 py-10">
        <div className="telesis-panel rounded p-8 md:p-10 border-l-2 border-yellow-400/60 telesis-rise">
          <p className="telesis-eyebrow">The volume of mentation</p>
          <blockquote className="mt-4 text-xl md:text-2xl lg:text-3xl font-semibold text-slate-100 leading-snug">
            “Each and every individual adds{" "}
            <span className="text-yellow-400">the value of one</span>{" "}
            to the volume of resonance of any idea held or circulating at any given time.”
          </blockquote>
          <p className="mt-5 text-sm text-slate-400 font-mono uppercase tracking-widest">
            Text · Image · Video — one voice, one unit of resonance
          </p>
        </div>
      </section>

      <section className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 py-10">
        <p className="telesis-eyebrow mb-3">The faculties</p>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="telesis-panel rounded p-6">
            <h3 className="text-lg font-semibold mb-2">Mentational Faculty</h3>
            <p className="text-sm text-slate-300">Each member casts unlimited "For" or "Against" votes on every post. If Against ≥ For, the piece <span className="text-rose-400 font-mono">BOUNCES</span> — all financing attempts fail until remedied.</p>
          </div>
          <div className="telesis-panel rounded p-6">
            <h3 className="text-lg font-semibold mb-2">Financier Split</h3>
            <p className="text-sm text-slate-300">Pledge funds and set the slider: never outside 20/80 — 80/20 between Voter Faculty (approvers) and the Original Author.</p>
          </div>
        </div>
      </section>

      <footer className="relative z-10 border-t border-[#1a1d28] mt-16 px-6 md:px-12 py-8 text-xs text-slate-500 font-mono flex flex-wrap gap-4 justify-between">
        <span>© 2026 TELESIS CAI PROTOCOL</span>
        <span>FOUNDER · STEVEN CRAIG BOILEAU</span>
      </footer>
    </div>
  );
}
